import $ from 'jquery';
import { isIOS, isAndroid } from 'irep/utilities/helpers';
const mainDisclaimer = $('#mainDisclaimer');
if (mainDisclaimer.length > 0) {
    mainDisclaimer.foundation('open');
    mainDisclaimer.on('click', '.continue', function (e) {
        e.preventDefault();
        mainDisclaimer.foundation('close');
        window.irep.getHtml({
            url: 'StoreDisclaimer.ajax'
        });
        if (isAndroid || isIOS) {
            let deviceType = isIOS ? "iOS"
                : isAndroid ? "android"
                    : "";
            window.irep.track("DisclaimerAccept", "mobile", deviceType, '', '');
        }
    });
}
const emailOptInPopup = $('#emailOptInPopUp');
if (emailOptInPopup.length > 0) {
    emailOptInPopup.foundation('open');
    window.irep.track("EmailOptInPopup", "PopupViewed", '', '', '');
    emailOptInPopup.on('click', '.optIn', function (e) {
        window.irep.track("EmailOptInPopup", "OptedIn", '', '', '');
        e.preventDefault();
        window.irep.getHtml({
            url: "api/emailOptIn/optIn",
            type: "POST",
            data: {}
        }).done(function () {
            $('#requestMessage').hide();
            $('#thanksMessage').show();
        });
    });
    emailOptInPopup.on('click', '.optOut', function (e) {
        window.irep.track("EmailOptInPopup", "Declined", '', '', '');
        e.preventDefault();
        emailOptInPopup.foundation('close');
    });
    emailOptInPopup.on('click', '.close', function (e) {
        e.preventDefault();
        emailOptInPopup.foundation('close');
    });
}
